import { IGetAllChecklistServicoUseCase } from "../../../presentation/useCases/read/get_all_checklist_servico_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ChecklistServico } from "../../models/checklist_servico";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllChecklistServicoUseCase
 */

export class GetAllChecklistServicoUseCase
  extends BasePaginatedUseCase<ChecklistServico>
  implements IGetAllChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllChecklistServico(
    tipoCampo: number | null,
    valorCampo: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllChecklistServico(
      tipoCampo,
      valorCampo,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
